import { render, staticRenderFns } from "./plutus.vue?vue&type=template&id=3dcfb39f&"
import script from "./plutus.vue?vue&type=script&lang=js&"
export * from "./plutus.vue?vue&type=script&lang=js&"
import style0 from "./plutus.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "plutus.vue"
export default component.exports